/**
 * `/` authenticated index — redirects to `/tenants` (Link Admin home per
 * CONTEXT D-12). Honors an optional `?redirect=` query param for deep-link
 * preservation through the login round-trip (D-06 open-redirect defense via
 * `safeRedirectPath`).
 *
 * Phase 6 replaces `/tenants` content with the real tenant list; this route
 * stays as a redirect indefinitely.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { safeRedirectPath } from "@linkhr/auth";

export const Route = createFileRoute("/_auth/")({
  beforeLoad: ({ search }) => {
    const redirectParam = (search as { redirect?: string }).redirect;
    if (typeof redirectParam === "string") {
      const safe = safeRedirectPath(redirectParam);
      if (safe !== null) {
        throw redirect({ to: safe });
      }
    }
    throw redirect({ to: "/tenants" });
  },
});
